<template>
  <validation-provider
    #default="{ errors }"
    name="bidding_imported"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      :label="labelName"
      label-for="bidding_imported"
      :label-class="labelClass"
    >
      <v-select
        id="bidding_imported"
        v-model="importedStatus"
        :class="errors.length > 0 ? 'error-select' : ''"
        :options="importedStatusOptions"
        :placeholder="'Licitação Importada'"
        :disabled="readonly"
        :clearable="!readonly"
      >
        <template #option="{ label }">
          <span>{{ label }}</span>
        </template>

        <template #selected-option="{ label }">
          <span>{{ label }}</span>
        </template>

      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'importedStatusValue',
    event: 'importedStatusChange',
  },
  props: {
    importedStatusValue: {
      type: [Object, Boolean],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelName: {
      type: String,
      required: false,
      default: 'Licitação Importada',
    },
    labelClass: {
      type: [String, Array],
      required: false,
      default: '',
    },
  },
  data() {
    const importedStatusOptions = [
      {
        label: 'Importadas',
        value: true,
      },
      {
        label: 'Não Importadas',
        value: false,
      },
      {
        label: 'Importadas & Não Importadas',
        value: null,
      },
    ]

    return {
      importedStatusOptions,
    }
  },
  computed: {
    importedStatus: {
      get() {
        return this.importedStatusValue
      },
      set(value) {
        const valueMap = {
          true: {
            label: 'Importadas',
            value: true,
          },
          false: {
            label: 'Não Importadas',
            value: false,
          },
          null: {
            label: 'Importadas & Não Importadas',
            value: null,
          },
        }

        this.$emit('importedStatusChange', valueMap[value] || value)
      },
    },
  },
  watch: {
    importedStatusValue(newVal) {
      this.importedStatus = newVal
    },
  },
  created() {
    this.$emit('ready', true)
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.v-select {
  background-color: #fff;
}

.vs__search {
  font-size: 1rem !important;
}
</style>
